import React, { useContext } from 'react';

import { hot } from 'react-hot-loader/root';

import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import MicrosoftEntraIDLandingHelmet from 'common/helmets/MicrosoftEntraIDLandingHelmet';
import Button from 'common/inputs/Button';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';

import AzureLogo from 'img/azure-logo-icon.png';
import CannyLogoIcon from 'img/canny-icon.svg';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

const MicrosoftEntraIDLanding = () => {
  const showIntercom = useContext(ShowIntercomContext);

  return (
    <div className="integrationsLanding withoutImage">
      <MicrosoftEntraIDLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={AzureLogo}
                alt="Microsoft Entra ID Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s Microsoft Entra ID Integration</h1>
              <p className="subtitle">
                Collect feedback from your employees with our Microsoft Entra ID integration.
              </p>
              <div className="links">
                <Button
                  buttonType="blackButton"
                  value="Contact us for access"
                  onTap={showIntercom}
                />
                <a
                  href="https://help.canny.io/en/articles/3896811-azure-active-directory-integration"
                  rel="noopener"
                  target="_blank"
                  className="LandingIntegrations__install-link">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Invite your team to share feedback in Canny</h2>
              <p className="subtitle">
                Let your employees log in to Canny with their Microsoft Entra ID account. See who is
                leaving you feedback.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Private feedback discussions</h2>
              <p className="subtitle">
                Private boards ensure only your team members can share feedback. Create separate
                boards for anything your team would like feedback on.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Easily manage Canny access</h2>
              <p className="subtitle">
                Automatically revoke Canny access when employees leave your company.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default hot(MicrosoftEntraIDLanding);
